import { ReactElement, useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { Modal } from 'components'
import { useBlendingService, useProductsService } from 'services'
import Dropdown from '../../../components/ui/Dropdown/Dropdown'
import { ModalBody, CustomBlendName } from '../Blends.styled'

const useNewBlendModal = (): [ReactElement, (args: any) => void] => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [blendName, setBlendName] = useState<string>('')
  const { getProducts } = useProductsService()
  const { checkExistingBlendName } = useBlendingService()
  const navigate = useNavigate()

  const createCheckExistingBlendNameMutation = useMutation(
    checkExistingBlendName,
    {
      onSuccess: () => {
        if (!selectedProductId) {
          return
        }

        const selectedProductObject = products?.results.find(
          (item) => item.id.toString() === selectedProductId
        )

        setIsOpen(false)
        navigate(`/blends/new/${selectedProductObject.id}`, {
          state: { blendName: blendName },
        })
      },
      onError: (error: { detail: string }) => {
        toast.error(error.detail)
      },
    }
  )

  const [selectedProductId, setSelectedProductId] = useState<
    string | undefined
  >()

  const { data: products } = useQuery({
    queryKey: ['products_list_dropdown'],
    queryFn: () => getProducts(),
  })

  const onClick = () => {
    createCheckExistingBlendNameMutation.mutate(blendName)
  }

  const toggleModal = () => setIsOpen(!isOpen)

  return [
    <Modal
      isOpen={isOpen}
      title="New Blend"
      okButtonType="submit"
      onConfirm={onClick}
      onClose={toggleModal}
      confirmButtonDisabled={!blendName || !selectedProductId}
    >
      <ModalBody>
        <CustomBlendName
          id="blend-name"
          label="Blend Name"
          variant="outlined"
          fullWidth
          value={blendName}
          onChange={(e) => {
            setBlendName(e.target.value.toString())
          }}
        />
        <Dropdown
          label="Select Blending Spec"
          options={
            products?.results?.map((product) => ({
              value: product.id.toString(),
              label: product.name,
            })) || []
          }
          value={selectedProductId}
          onChange={(event) => {
            setSelectedProductId(event.target.value)
          }}
        />
      </ModalBody>
    </Modal>,
    () => {
      toggleModal()
    },
  ]
}

export default useNewBlendModal
